
@use '@design/bapf-pattern-library/source/sass/globals' as *;

// nach den globalen Einstellungen können wir benötigte Bootstrap-Komponenten und externe Bibliotheken einbinden
@use '@design/bapf-pattern-library/source/sass/vendor/bootstrap';

// alles eingestellt, jetzt folgen unsere node_modules/@design/bapf-pattern-library/source/sass/patterns
@use '@design/bapf-pattern-library/source/sass/patterns/footer';
@use '@design/bapf-pattern-library/source/sass/patterns/button';
@use '@design/bapf-pattern-library/source/sass/patterns/link';
@use '@design/bapf-pattern-library/source/sass/patterns/copytext';
@use '@design/bapf-pattern-library/source/sass/patterns/collapsible';
@use '@design/bapf-pattern-library/source/sass/patterns/richtext-content';
@use '@design/bapf-pattern-library/source/sass/patterns/accordion';
@use '@design/bapf-pattern-library/source/sass/patterns/list';
@use '@design/bapf-pattern-library/source/sass/patterns/form';
@use '@design/bapf-pattern-library/source/sass/patterns/social-links';


.initializing {
  display: none;
}

// Override since first element is an anchor tag instead of Copyright text
.ba-list-meta {
  li:first-child {
    padding: 0 0 0 !important;
  }
  li:last-child {
    padding: 4px 0 5px !important;
  }
}
